import moment from 'moment'
import momentTz from 'moment-timezone'

export default class Formatters {
    
    static formatDateTime(value) {
        if (value == null) {
            return ''
        }
        else {
            value = moment.tz(value, 'UTC')
            return moment.tz(value, momentTz.tz.guess()).format('MMMM Do, YYYY, h:mm:ss a')
        }
    }
    static formatDate(value) {
        if (value == null || value == "1900-01-01T00:00:00") {
            return ''
        }
        else {
            return moment.tz(value, 'UTC').format('MMMM Do, YYYY')
        }
    }

    static formatByteCapacity(value) {
        return (value > 100000)
        ? Math.round(value / 1000000000)
        : value
    }

    static formatMacAddress(value) {
        var result = ''
        for (let adapter of value) {
            result += adapter.macAddress + ', '
        }
        return result.slice(0, -2)
    }
}